/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { MedicalServiceBaseDto } from './medical-service-base-dto';

/**
 * 
 * @export
 * @interface DoctorWorkPlanPosDto
 */
export interface DoctorWorkPlanPosDto {
    /**
     * 
     * @type {boolean}
     * @memberof DoctorWorkPlanPosDto
     */
    'docplannerEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorWorkPlanPosDto
     */
    'doctorPackageEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DoctorWorkPlanPosDto
     */
    'id'?: number;
    /**
     * 
     * @type {Array<MedicalServiceBaseDto>}
     * @memberof DoctorWorkPlanPosDto
     */
    'medicalServices'?: Array<MedicalServiceBaseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorWorkPlanPosDto
     */
    'singleDoctorEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DoctorWorkPlanPosDto
     */
    'timeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorWorkPlanPosDto
     */
    'timeTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorWorkPlanPosDto
     */
    'visitType'?: DoctorWorkPlanPosDtoVisitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DoctorWorkPlanPosDto
     */
    'weekday'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoctorWorkPlanPosDto
     */
    'workPlaceId'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum DoctorWorkPlanPosDtoVisitTypeEnum {
    Remote = 'REMOTE',
    Stationary = 'STATIONARY',
    Absent = 'ABSENT'
}


